import { Button, classnames, RadioButtonItem } from '@terveystalo/design-system-react-components';
import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { sendAppCompleted, sendMessage } from 'utils/communication/useSendMessages';
import { assertExhausted } from 'utils/types/misc';

enum Topic {
  ILLNESS = 'illness',
  OTHER = 'other',
}

type Props = {
  onClickNext: () => void;
};

export const StartPage: FC<Props> = ({ onClickNext }) => {
  const { t } = useTranslation();
  const questionareOption = Topic.ILLNESS;
  const [selected, setSelected] = useState<Topic>(questionareOption);
  const [error, setError] = useState<boolean>(false);

  // TODO Accessibility

  const goToNext = function (option: Topic) {
    switch (option) {
      case Topic.ILLNESS: // Proceed to questionare
        return onClickNext();
      case Topic.OTHER: // Skip questionare and go to chat
        return window.terveystaloApp
          ? sendAppCompleted()
          : sendMessage({ type: 'Completed', payload: { metadata: undefined } });
      default:
        return assertExhausted(option);
    }
  };

  const onChange = function (option: Topic) {
    setSelected(option);
    setError(false);
  };

  return (
    <div className={classnames('flex', 'flex-col', 'mb-2')}>
      <h1 className={classnames('text-style-subtitle-mplus', 'mb-0.5')}>{t('what_its_about')}</h1>
      <div className={classnames('mb-1')}>
        <RadioButtonItem
          label={t('illness')}
          name="chat-topic"
          checked={selected === Topic.ILLNESS}
          onChange={() => onChange(Topic.ILLNESS)}
        />
        <RadioButtonItem
          label={t('other_reason')}
          name="chat-topic"
          checked={selected === Topic.OTHER}
          onChange={() => onChange(Topic.OTHER)}
        />
      </div>
      {error && <p className={classnames('mb-0.5')}>Something went wrong</p>}
      <Button id="next-button" as="button" onClick={() => goToNext(selected)} disabled={error}>
        {t('next')}
      </Button>
    </div>
  );
};
